/**
 * Sincroniza la divisa del CARRITO con la que se está mostrando.
 * ============================================================================
 * GOTCHA de Markets (heredado del Pipeline, NOTAS §"Moneda base"): el carrito
 * guarda la divisa con la que se creó. Si el comprador cae en frío en un mercado
 * USD y luego la página se pinta en EUR (o al revés, si cambia de país con el
 * selector del footer), el sidecart sigue mostrando la divisa vieja: se ven
 * precios en $ con la web en € y viceversa.
 *
 * Aquí se corrige de forma REACTIVA: cada vez que el carrito cambia, si
 * `cart.currency` != la divisa activa de la página, se re-envía el país actual
 * al endpoint `/localization` (eso reconvierte el carrito) y se pide al sidecart
 * que se repinte. NO se fuerza ninguna recarga de página: el país lo manda el
 * selector del footer, no una heurística sobre la URL.
 *
 * Además, una migración versionada corrige UNA VEZ las cookies antiguas de
 * Markets. Es el caso de visitantes españoles que conservaron US/USD de la web
 * anterior aunque Shopify ya detecte ES. Después de esa única resincronización,
 * el selector manual vuelve a mandar y no se sobreescribe la elección del usuario.
 *
 * El país/idioma que se re-envía los pinta Liquid en los data-* de este <script>
 * (ver layout/theme.liquid). Contrato de refresco: `cart:updated`
 * (iurop-cart-drawer.js escucha ese evento y recarga la sección).
 */
(function () {
  'use strict';

  if (window.__iuropMarketSync) return;
  window.__iuropMarketSync = true;

  var el = document.currentScript;
  var COUNTRY = (el && el.getAttribute('data-country')) || '';
  var LANGUAGE = (el && el.getAttribute('data-language')) || '';
  var ACTIVE = (el && el.getAttribute('data-currency')) || '';
  var ROOT = (el && el.getAttribute('data-root')) || '/';
  // El visitante ha elegido país con el selector del footer: su decisión manda
  // por encima de la geolocalización, para siempre.
  var MANUAL_KEY = 'iurop:market-manual';

  if (!COUNTRY || !ACTIVE) return;

  var fixing = false;

  function commit(then) {
    var body = new URLSearchParams();
    body.set('form_type', 'localization');
    body.set('_method', 'put');
    body.set('country_code', COUNTRY);
    if (LANGUAGE) body.set('language_code', LANGUAGE);
    body.set('return_to', ROOT);
    fetch(ROOT.replace(/\/$/, '') + '/localization', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: body.toString(),
      keepalive: true
    }).then(function () { then && then(); }, function () { then && then(); });
  }

  function syncCart() {
    if (fixing) return;
    fetch(ROOT.replace(/\/$/, '') + '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (!cart || !cart.currency || cart.currency === ACTIVE) return;
        fixing = true;
        commit(function () {
          fixing = false;
          // El carrito ya está reconvertido: que el sidecart se repinte con los
          // importes nuevos. `noOpen` es el contrato de iurop-cart-drawer.js
          // para refrescar SIN abrir el cajón (esto no lo ha pedido el usuario).
          document.dispatchEvent(new CustomEvent('cart:updated', {
            detail: { noOpen: true, marketSync: true }
          }));
        });
      })
      .catch(function () {});
  }


  function submitSuggestedCountry(country) {
    var form = document.createElement('form');
    form.method = 'post';
    form.action = ROOT.replace(/\/$/, '') + '/localization';
    form.hidden = true;

    var values = {
      form_type: 'localization',
      _method: 'put',
      country_code: country,
      language_code: LANGUAGE,
      return_to: window.location.pathname + window.location.search + window.location.hash
    };

    Object.keys(values).forEach(function (name) {
      if (!values[name]) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = values[name];
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
  }

  // QA 2026-08-14 (T2): esto era una migración de UN SOLO USO (localStorage
  // iurop_geo_sync_2026_08_06) y además se marcaba como hecha ANTES de saber si
  // había corregido algo. Resultado: quien entraba en frío por la raíz (anuncio,
  // Google, enlace compartido) se quedaba en el mercado internacional, en dólares,
  // para siempre. Ahora se evalúa en CADA carga mientras el país detectado no
  // coincida con el activo. No hay bucle posible: el endpoint se consulta
  // EXCLUYENDO el país activo, así que en cuanto acierta deja de sugerir.
  // Lo único que lo desactiva es que el visitante haya elegido país A MANO.
  // NOTA: esto es un sustituto de la redirección NATIVA de Shopify Markets, que
  // es server-side y trata bien a los buscadores. Si algún día se activa en el
  // admin, esta función se vuelve inocua (no habrá desajuste que corregir).
  function userPickedCountry() {
    try { return window.localStorage.getItem(MANUAL_KEY) === '1'; }
    catch (e) { return false; }
  }

  function syncLegacyMarketCookie() {
    if (userPickedCountry() || (window.Shopify && window.Shopify.designMode)) return;

    var endpoint = ROOT.replace(/\/$/, '') + '/browsing_context_suggestions.json'
      + '?country%5Benabled%5D=true'
      + '&country%5Bexclude%5D=' + encodeURIComponent(COUNTRY);

    fetch(endpoint, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('market suggestion unavailable');
        return response.json();
      })
      .then(function (data) {
        var suggestion = data && data.suggestions && data.suggestions[0];
        var country = suggestion && suggestion.parts && suggestion.parts.country;
        var suggested = country && country.handle;

        if (!suggested || suggested === COUNTRY || Number(country.confidence || 0) < 0.99) return;
        submitSuggestedCountry(suggested);
      })
      .catch(function () {
        // No marcamos la migración como terminada para poder reintentar en otra página.
      });
  }

  // Red de seguridad: cualquier add/change del carrito, venga del tema o de una
  // app, dispara la comprobación.
  var reCart = /\/cart\/(add|change|update)/;
  try {
    var _fetch = window.fetch;
    window.fetch = function (input) {
      var ret = _fetch.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (reCart.test(u)) ret.then(function () { window.setTimeout(syncCart, 80); }, function () {});
      } catch (e) { /* noop */ }
      return ret;
    };
    var _open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      try {
        if (reCart.test(url || '')) {
          this.addEventListener('load', function () { window.setTimeout(syncCart, 80); });
        }
      } catch (e) { /* noop */ }
      return _open.apply(this, arguments);
    };
  } catch (e) { /* noop */ }

  // El selector de país del footer envía un form 'localization' con country_code.
  // Al hacerlo, se marca la elección como MANUAL para no volver a redirigir.
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest && e.target.closest('select[name="country_code"]');
    if (!sel) return;
    try { window.localStorage.setItem(MANUAL_KEY, '1'); } catch (err) {}
  }, true);

  document.addEventListener('cart:updated', function (e) {
    // Evita el bucle: el refresco que lanzamos nosotros no vuelve a comprobar.
    if (e && e.detail && e.detail.marketSync) return;
    syncCart();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      syncLegacyMarketCookie();
      syncCart();
    });
  } else {
    syncLegacyMarketCookie();
    syncCart();
  }
})();
